module.exports = __webpack_public_path__ + "img/116.1e9c655d.jpg";